import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';

import storage from 'redux-persist/lib/storage';
import authReducer from "./Features/Auth/authSlice"
import watchReducer from "./Features/Watch/watchSlice"
import readReducer from "./Features/Read/readSlice"
import learnReducer from "./Features/Learn/learnSlice"
import activeReducer from "./Features/Misc/activeSlice"
import navBarReducer from "./Features/Misc/navBarSlice"
import loginReducer from "./Features/Misc/loginSlice"
import accountTypeReducer from "./Features/Misc/accountTypeSlice"
import offCanvasReducer from "./Features/Misc/offCanvasSlice"
import mediaReducer from "./Features/Media/mediaSlice"
import faveReducer from "./Features/Favourites/faveSlice"
import paymentReducer from "./Features/Payment/paymentSlice"
import stripeReducer from "./Features/Stripe/StripeSlice"

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['payment', "stripe"],
    whitelist: ["auth", "watch", "read", "learn"],
    purge: async () =>{
        await storage.removeItem("persist:root");
    }
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);
const persistedWatchReducer = persistReducer(persistConfig, watchReducer);
const persistedReadReducer = persistReducer(persistConfig, readReducer);
const persistedLearnReducer = persistReducer(persistConfig, learnReducer);
const persistedActiveReducer = persistReducer(persistConfig, activeReducer);
const persistedNavBarReducer = persistReducer(persistConfig, navBarReducer);
const persistedLoginReducer = persistReducer(persistConfig, loginReducer);
const persistedAccountTypeReducer = persistReducer(persistConfig, accountTypeReducer);
const persistedOffCanvasReducer = persistReducer(persistConfig, offCanvasReducer);
const persistedMediaReducer = persistReducer(persistConfig, mediaReducer);
const persistedFaveReducer = persistReducer(persistConfig, faveReducer);
const persistedPaymentReducer = paymentReducer;
const persistedStripeReducer = stripeReducer;



export const store = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        watches: persistedWatchReducer,
        reads: persistedReadReducer,
        learns: persistedLearnReducer,
        active: persistedActiveReducer,
        navBar: persistedNavBarReducer,
        login: persistedLoginReducer,
        accountType: persistedAccountTypeReducer,
        offCanvas: persistedOffCanvasReducer,
        media: persistedMediaReducer,
        fave: persistedFaveReducer,
        payment: persistedPaymentReducer,
        stripe: persistedStripeReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export {persistConfig}

export const persistor = persistStore(store);
